// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j680","type":"styles_type__DyC3_","choices":"styles_choices__2rYJ3"};